import * as React from "react";
import {PropsWithChildren, useState} from "react";
import {Checkbox} from "react-bootstrap";
import {
    defineMessages,
    FormattedDate,
    FormattedMessage,
    FormattedTime,
    InjectedIntlProps,
    injectIntl
} from "react-intl";
import {generatePath, RouteComponentProps} from "react-router";
import {Api} from "../../api/InternalApi";
import {ColumnsDescription, ColumnWidth} from "../../common/ui/table/ControlRoomColumns";
import {generateUrl} from "../../common/util/Util";
import {WithApi, WithApiProperties} from "../../common/util/WithApi";
import {AOINotificationEvent} from "../model";

function openDatasetsPage(api: Api, event: AOINotificationEvent) {
    return api.getNotificationEventDetails(event.id, event.monitorUserId)
        .then((details) => {
            const url = generateUrl(generatePath("/data/:datasets", {
                datasets: details.dataId,
            }));
            window.open(url, '_blank');
        });
}

const MESSAGES = defineMessages({
    opening: {
        id: "studio.notifications.aoi-events-list-columns.link-opening",
        defaultMessage: "Opening...",
    }
});

const GetDatasetsLinkComponent = (props: {
    event: AOINotificationEvent,
} & PropsWithChildren<any> & RouteComponentProps & InjectedIntlProps & WithApiProperties) => {
    const {children, intl, api, event} = props;
    const [opening, setOpening] = useState(false);

    return <a
        href="#"
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            setOpening(true);
            openDatasetsPage(api, event)
                .then(() => {
                    setOpening(false);
                });
        }}>{opening ? intl.formatMessage(MESSAGES.opening) : children}</a>
};
const GetDatasetsLink = WithApi(injectIntl(GetDatasetsLinkComponent));

export const AOIEventsColumns: ColumnsDescription<AOINotificationEvent> = {
    name: {
        header: <FormattedMessage id="studio.notifications.aoi-events-list-columns.time" defaultMessage="Time"/>,
        cellContent(event) {
            return <GetDatasetsLink event={event}>
                <FormattedDate value={event.timestamp}/> <FormattedTime value={event.timestamp}/>
            </GetDatasetsLink>;
        },
        columnWidth: ColumnWidth.flex(1),
    },
    hasBeenRead: {
        header: <FormattedMessage id="studio.notifications.aoi-events-list-columns.has-been-read"
                                  defaultMessage="Has been read"/>,
        cellContent(event) {
            return <Checkbox data-is-has-been-read-checkbox={true} className="checkbox-center"
                             checked={event.hasBeenRead} onChange={() => null}/>;
        },
        columnWidth: ColumnWidth.pixels(120),
    },
};